import * as React from "react";
import { ConditionalChildren } from "azure-devops-ui/ConditionalChildren";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class ConditionalChildrenExample extends React.Component {
    private showChild3 = new ObservableValue<boolean>(false);
    private showChild4 = new ObservableValue<boolean>(true);

    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <ConditionalChildren renderChildren={true}>
                    <div>Child 1</div>
                </ConditionalChildren>
                <ConditionalChildren renderChildren={false}>
                    <div>Child 2</div>
                </ConditionalChildren>
                <ConditionalChildren renderChildren={this.showChild3}>
                    <div>Child 3</div>
                </ConditionalChildren>
                <ConditionalChildren renderChildren={this.showChild4}>
                    <div>Child 4</div>
                </ConditionalChildren>
            </div>
        );
    }
}
